<template>
  <div id="app">
    <router-view />    
  </div>
</template>
<script>

import { mapState, mapGetters, mapActions } from "vuex";
//import { storage, isIE, subdomain }         from "@/utils";

export default {
  data() {
    return {
      keymap: {},
    };
  },
  watch: {
    "$route.path"() {
    }
  },
  created() {
    //this.preloadFonts();
  },
  computed:
  {
    ...mapState(["siteReady"]),
  },
  methods: {
    ...mapActions(["setSiteReady"]),
  }
};
</script>

<style>
:root {  
  --graybg1:#eee;
  --text-blue: #40738d;
  --dark-blue:#030f1a;
  --text-gray-dark:#3f3f3f;
}
ul{
  padding-inline-start:0px;
  margin-block-start: 0px;
  margin-block-end: 0px;  
}
#app
{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
   font-family:Inter,NimbusSanNovLig W05 Regular, neue-haas-grotesk-display, Helvetica, Arial;  
}
</style>
